import { useRouter } from 'next/router'
import { FunctionPropTypes } from '~shared/types/utils'
import { calculateClosestEnrollment } from '~shared/utils/calculateClosestEnrollment'

export const useCalculateClosestEnrollment = ({
  timestamp,
  isCourse
}: Omit<
  FunctionPropTypes<typeof calculateClosestEnrollment>,
  'months' | 'locale'
>) => {
  const { locale } = useRouter()
  const months = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь'
  ]

  return calculateClosestEnrollment({ timestamp, months, locale, isCourse })
}
